import React from "react";
import "./CheckoutProduct.css";
import fulfil from "./Assets/fulfil.PNG";
import { useStateValue } from "./StateProvider";
function CheckoutProduct(props) {
  const [state, dispatch] = useStateValue();
  const removeitemfrombasket = (i) => {
    dispatch({
      type: "REMOVE_FROM_BASKET",
      id: i,
    });
  };
  var fulfilimg = null;
  if (
    state.basket.reduce(
      (total, args) => total + parseFloat(args?.price.replace(/,/g, "")),
      0
    ) > 499
  ) {
    fulfilimg = (
      <div className="checkoutproduct_fufil">
        <span>
          <small>Eligible for FREE Shipping</small>
        </span>
        <img src={fulfil}></img>
      </div>
    );
  }

  return (
    <div className="checkoutproduct">
      <img src={props.details.image} className="checkoutproduct_image"></img>
      <div className="checkoutproduct_info">
        <p className="checkoutproduct_title">{props.details.title}</p>

        <p className="checkoutproduct_price">
          <big>₹ </big>
          <strong>{props.details.price}</strong>
        </p>
        {fulfilimg}
        <div className="checkoutproduct_rating">
          {Array(props.details.rating)
            .fill()
            .map(() => (
              <p>⭐</p>
            ))}
        </div>

        <button onClick={removeitemfrombasket.bind(this, props.details.id)}>
          Remove from Cart
        </button>
      </div>
    </div>
  );
}

export default CheckoutProduct;
